/**
 * Timeline reporting (spec: project-portfolio-reporting.md, Story 2).
 *
 * Read-only aggregation over `time_entries` (hours) plus `cost_rates`
 * (revenue's effective rate) — no persisted state of its own. One series per
 * project that has at least one booked minute within the rolling window;
 * projects without hours in the window are omitted entirely (spec AC:
 * "erscheinen nicht in der Legende/den Serien").
 */

export interface ProjectTimelineProject {
  id: string;
  number: string;
  name: string;
}

export interface ProjectTimelineSeries {
  projectId: string;
  /** Booked hours per month, aligned with `ProjectTimelineReport.months` (ALL entries, regardless of `billable`). */
  hours: number[];
  /**
   * Revenue per month (billable hours × the project's effective cost rate),
   * aligned with `months`. `null` (the whole array) when the project has no
   * resolvable cost rate (project default, else global default) — shown as
   * "—" rather than 0, consistent with Story 4 AC2.
   */
  revenue: number[] | null;
}

export interface ProjectTimelineReport {
  /** Ascending `YYYY-MM` labels, oldest first. */
  months: string[];
  /** Only projects with hours in the window, ordered by project number. */
  projects: ProjectTimelineProject[];
  /** One entry per project in `projects`, same order/length. */
  series: ProjectTimelineSeries[];
  /**
   * Running total of revenue across every project with a resolvable rate,
   * aligned with `months` (the "kumulierte Linie" over the whole window).
   */
  cumulativeRevenue: number[];
}
